/**
 * @flow
 * /

/** TODO: here we are getting error when gls is loaded here, so, we will debug that in v2 (tracker: https://tracker.apigateway.in/issues/2648) */

import React from 'react'
import { withPrefix } from 'gatsby-link'
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import {
  isValidEmailId,
  isValidInternationalPhoneNumber,
  isRequired
} from '../../../utils/FormValidations'
import { isIndia, getCountry, getState } from '../../../utils/googlePlacesUtils'
import { scrollToSection } from '../../../utils/navigationUtils'
import { submitFormAPI } from '../../../utils/forms.js'
import {
  formMode,
  BUSINESS,
  EMPLOYEE
} from '../../../constants/ApplyForFranchiseConstants'
import {
  dropDownFields,
  employeeFields,
  businessFields,
  ageDropDownFields,
  ClosedQuestionDropDownFields,
  WhichOpportunityAreYouInterestedInFields
} from './dropDownFields'

import LocationSearchInput from './LocationSearchInput'
import './index.scss'

import {
  ApplyForFormSection,
  Heading,
  FormContainer,
  InputComponent,
  Button,
  SuccessText,
  PrimaryThankYouText,
  SecondaryThankYouText,
  ButtonWrapper,
  Loading,
  OccupationSelectInput,
  RadioButtonContainer,
  RadioButtonLabel,
  RadioButtonHeading,
  RadioButtonsWrapper,
  EmployeeeSelectInput,
  BusinessSelectInput,
  EmptyInputComponent,
  AgeSelectInput,
  TextAreaComponent,
  PreferredLocationHeading,
  WhyAreYouInterestedHeading,
  SuccessContainer,
  ResponsiveContainer,
  HaveYouExperienceIBCricketInput,
  DoYouHaveSpaceAvailableForSetupField,
  WhichOpportunityAreYouInterestedInput
} from './styledComponents'

class ApplyForFranchiseForm extends React.Component {
  static defaultProps = {
    required: 'Error',
    formHeading: 'Leave your details below and we will get in touch with you!'
  }
  constructor(props) {
    super(props)
    this.state = {
      submissionStatus: false,
      formMode: formMode.indianDefault,
      residenceState: '',
      residenceCountry: '',
      businessCountry: '',
      businessState: ''
    }
  }

  clearTextInput = () => {
    this.emailRef.state.value = ''
    this.nameRef.state.value = ''
    this.phoneRef.state.value = ''
    this.occupationRef.state.value = ''
    this.placesInputRef.clearValues()
    this.cityOfResidenceRef.clearValues()
    let form = document.getElementById('ApplyFranchiseForm')
    form.reset()
    this.setState({
      residenceState: '',
      residenceCountry: '',
      businessCountry: '',
      businessState: ''
    })
  }

  storePlacesInputRef = ref => {
    this.placesInputRef = ref
  }

  storeEmailRef = ref => {
    this.emailRef = ref
  }

  storeNameRef = ref => {
    this.nameRef = ref
  }
  storeLastNameRef = ref => {
    this.lastNameRef = ref
  }
  storeAgeRef = ref => {
    this.ageRef = ref
  }

  storeHaveYouExperienceIBCricketRef = ref => {
    this.haveYouExperienceIBCricketRef = ref
  }

  storeWhichOpportunityAreYouIntrested = ref =>{
    this.whichOpportunityAreYouIntrestedRef = ref
  }

  storeDoYouHaveSpaceAvailableForSetupRef = ref => {
    this.doYouHaveSpaceAvailableForSetupRef = ref
  }

  storePhoneRef = ref => {
    this.phoneRef = ref
  }
  storeCitiesInputRef = ref => {
    this.cityOfResidenceRef = ref
  }

  storeOccupationRef = ref => {
    this.occupationRef = ref
  }

  storeOccupationSpecificRef = ref => {
    this.occupationSpecificRef = ref
  }
  storeResidenceCountryRef = ref => {
    this.residenceCountryRef = ref
  }

  storeBusinessCountryRef = ref => {
    this.businessCountryRef = ref
  }

  storeWhyAreYouInterestedRef = ref => {
    this.whyAreYouInterestedRef = ref
  }

  validateAllFields = () => {
    // CityFieldValidation
    const cityValidationResponse = this.placesInputRef.validate()
    const isValidCityField = !cityValidationResponse.displayError
    // CityFieldValidation
    const cityOfResidenceValidationResponse = this.cityOfResidenceRef.validate()
    const isValidCityOfResidenceField = !cityOfResidenceValidationResponse.displayError
    // EmailFieldValidation
    const emailValidationResponse = this.emailRef.validate()
    const isValidEmailField = !emailValidationResponse.displayError
    // NameValidation
    const nameValidationResponse = this.nameRef.validate()
    const isValidNameField = !nameValidationResponse.displayError
    // LastName validation
    const lastNameValidationResponse = this.lastNameRef.validate()
    const isValidLastNameField = !lastNameValidationResponse.displayError
    // Age validation
    const ageValidationResponse = this.ageRef.validate()
    const isValidAgeField = !ageValidationResponse.displayError

    // haveYouExperienceIBCricket validation
    const haveYouExperienceIBCricketValidationResponse = this.haveYouExperienceIBCricketRef.validate()
    const isValidHaveYouExperienceIBCricketField = !haveYouExperienceIBCricketValidationResponse.displayError

    const whichOpportunityAreYouIntrestedResponse = this.whichOpportunityAreYouIntrestedRef.validate()
    const isValidWhichOpportunityAreYouIntrestedField = !whichOpportunityAreYouIntrestedResponse.displayError

    // doYouHaveAnySpaceReadilyAvailableToSetUpIBCricket validation
    const doYouHaveSpaceAvailableForSetupValidationResponse = this.doYouHaveSpaceAvailableForSetupRef.validate()
    const isValiddoYouHaveSpaceAvailableForSetupField = !doYouHaveSpaceAvailableForSetupValidationResponse.displayError

    // Business validation
    let isValidBusinessField = true
    if (this.businessRef) {
      const businessValidationResponse = this.businessRef.validate()
      isValidBusinessField = !businessValidationResponse.displayError
    }

    // OccupationValidation
    let isValidOccupationField = true
    if (this.occupationRef) {
      const occupationValidationResponse = this.occupationRef.validate()
      isValidOccupationField = !occupationValidationResponse.displayError
    }

    let isValidOccupationSpecificField = true
    if (this.occupationSpecificRef) {
      isValidOccupationSpecificField = !this.occupationSpecificRef.validate()
        .displayError
    }

    // PhoneValidation
    const phoneValidationResponse = this.phoneRef.validate()
    const isValidPhoneField = !phoneValidationResponse.displayError

    // Country Validation

    const isValidCountry = !this.residenceCountryRef.validate().displayError

    const isValidBusinessCountry = !this.businessCountryRef.validate()
      .displayError
    const isValidWhyAreYouInterested = !this.whyAreYouInterestedRef.validate()
      .displayError

    return (
      isValidCityField &&
      isValidEmailField &&
      isValidPhoneField &&
      isValidNameField &&
      isValidLastNameField &&
      isValidAgeField &&
      isValidHaveYouExperienceIBCricketField &&
      isValidOccupationField &&
      isValidOccupationSpecificField &&
      isValidBusinessField &&
      isValidCityOfResidenceField &&
      isValidCountry &&
      isValiddoYouHaveSpaceAvailableForSetupField &&
      isValidBusinessCountry &&
      isValidWhyAreYouInterested
    )
  }

  goBack = () => {
    this.setState(
      { formMode: formMode.indianDefault },
      () => history.replaceState('', '', withPrefix('/franchise/')) //eslint-disable-line
    )
  }

  onFailureSubmitForm = () => {
    // TODO: Need to ask for UI to design team: @dependency on Anesh,Design
  }
  toCamelCase = name =>
    name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

  submitForm = () => {
    const { addressValues, residenceAddressValues } = this
    const name = this.toCamelCase(this.nameRef.state.value)

    const formElement = document.getElementById('ApplyFranchiseForm')
    const htmlFormData = new FormData(formElement)
    const radioButtonGroupValue = htmlFormData.get('radio') //eslint-disable-line
    let salary = null
    let annualTurnover = null
    switch (this.state.formMode) {
      case formMode.indianBusiness:
      case formMode.otherCountryBusiness:
        annualTurnover = this.occupationSpecificRef.state.value
        break
      case formMode.indianEmployee:
      case formMode.otherCountryEmployee:
        salary = this.occupationSpecificRef.state.value
        break
      default:
    }
    const { residenceState, businessState, businessCountry } = this.state

    const formData = {
      First_Name: name,
      Last_Name: this.lastNameRef.state.value,
      Age: this.ageRef.state.value,
      Have_you_experienced_iB_Cricket: this.haveYouExperienceIBCricketRef.state
        .value,
      Which_opportunity_are_you_interested_in:this.whichOpportunityAreYouIntrestedRef.state.value ,
      Email_ID: this.emailRef.state.value,
      Mobile_Number: this.phoneRef.state.value,
      Occupation: this.occupationRef.state.value,
      Salary_per_annum: salary,
      Annual_turnover: annualTurnover,

      City_of_Residence: this.cityOfResidenceRef.state.address,
      State: residenceState,
      Country: this.residenceCountryRef.state.value,

      Is_space_available_for_the_setup: this
        .doYouHaveSpaceAvailableForSetupRef.state.value,

      Address: JSON.stringify(residenceAddressValues),

      // // Preferred Location to Setup a Franchise:
      Preferred_City_Town: this.placesInputRef.state.address,
      Preferred_State: businessState,
      Preferred_Country: businessCountry,

      Preferred_Location_Address: JSON.stringify(addressValues),

      // Other information
      Any_previous_experience_in_Business: radioButtonGroupValue,
      Why_are_you_interested_in_taking_up_business_with_iB_Cricket: this
        .whyAreYouInterestedRef.state.value
    }
    const requestObject = {
      submission_data: formData,
      form_unique_code: 'iB_Cricket_Franchise_Opportunities'
    }
    submitFormAPI(requestObject, () => {}, this.onFailureSubmitForm)
    this.onFormSubmitSuccess()
  }

  submitFormData = () => {
    const { address } = this.placesInputRef.state
    const { address: residenceAddress } = this.cityOfResidenceRef.state
    this.address = address
    this.city_of_residence_address = residenceAddress

    Promise.all([geocodeByAddress(address), geocodeByAddress(residenceAddress)])
      .then(([addressResutls, residenceAddressResults]) => {
        const addressValues = addressResutls[0]
        const residenceAddressValues = residenceAddressResults[0]
        if (this.addressValues !== 'undefined') {
          this.addressValues = addressValues
        }
        if (this.residenceAddressValues !== 'undefined') {
          this.residenceAddressValues = residenceAddressValues
        }
        return Promise.all([
          getLatLng(addressValues),
          getLatLng(residenceAddressValues)
        ])
      })
      .then(([franchiseLatLng, residenceLatLng]) => {
        this.franchiseLatLng = JSON.stringify(franchiseLatLng)
        this.residenceLatLng = JSON.stringify(residenceLatLng)
      })
      .catch(e => {
        const { PlacesServiceStatus } = window.google.maps.places
        switch (e) {
          case PlacesServiceStatus.ZERO_RESULTS:
            return
          case PlacesServiceStatus.OVER_QUERY_LIMIT:
          case PlacesServiceStatus.REQUEST_DENIED:
          case PlacesServiceStatus.INVALID_REQUEST:
          case PlacesServiceStatus.UNKNOWN_ERROR:
          default:
            throw e
        }
      })
      .then(() => {
        this.submitForm()
      })
      .catch(e => console.error(e))

    return null
  }

  onFormSubmitSuccess = () => {
    this.clearTextInput()
    this.setState(
      {
        submissionStatus: true,
        formMode: formMode.submitted
      },
      () => {
        history.replaceState(
          '',
          '',
          withPrefix('/business-opportunities/thankyou/')
        ) //eslint-disable-line
        scrollToSection('ApplyFranchiseFormThankYou')
      }
    )
  }

  handleChange = () => {
    // TO remove ThankYou message after user changes
    this.setState({
      submissionStatus: false
    })
  }
  setResidenceCountryField = value => {
    this.residenceCountryRef.state.value = value
    this.residenceCountryRef.state.displayError = false
    this.residenceAddressValues = ''
    this.setState({ residenceCountry: value })
    this.handleCountryChange()
  }
  setResidenceStateField = value => {
    this.setState({ residenceState: value })
  }
  handleResidenceError = () => {
    this.residenceCountryRef.state.value = ''
    this.residenceAddressValues = 'undefined'
    this.setState({ residenceCountry: '', residenceState: '' })
  }
  handleResidenceLocationCountryError = error => {
    console.error('Error in getting  residence country', error)
    this.residenceCountryRef.state.value = ''
    this.residenceAddressValues = 'undefined'
    this.setState({ residenceCountry: '' })
  }
  handleResidenceCityBlur = address => {
    this.setState({
      submissionStatus: false
    })
    geocodeByAddress(address)
      .then(results => getCountry(results[0]))
      .then(this.setResidenceCountryField)
      .catch(error => this.handleResidenceLocationCountryError(error))
    geocodeByAddress(address)
      .then(results => getState(results[0]))
      .then(this.setResidenceStateField)
      .catch(error => console.error('Error in getting residence state', error))
  }

  setBusinessCountryField = value => {
    this.businessCountryRef.state.displayError = false
    this.businessCountryRef.state.value = value
    this.addressValues = ''
    this.setState({ businessCountry: value })
  }
  setBusinessStateField = value => {
    this.setState({ businessState: value })
  }
  handleBusinessError = () => {
    this.businessCountryRef.state.value = ''
    this.setState({ businessCountry: '', businessState: '' })
    this.addressValues = 'undefined'
  }
  handleBusinessLocationCountryError = error => {
    console.error('Error in getting  business country', error)
    this.businessCountryRef.state.value = ''
    this.addressValues = 'undefined'
    this.setState({ businessCountry: '' })
  }
  handleBusinessCityBlur = address => {
    this.setState({
      submissionStatus: false
    })
    geocodeByAddress(address)
      .then(results => getCountry(results[0]))
      .then(this.setBusinessCountryField)
      .catch(error => this.handleBusinessLocationCountryError(error))
    geocodeByAddress(address)
      .then(results => getState(results[0]))
      .then(this.setBusinessStateField)
      .catch(error => console.error('Error in getting business state', error))
  }

  handleOccupationChange = value => {
    const isInIndianMode = () => {
      switch (this.state.formMode) {
        case formMode.indianBusiness:
        case formMode.indianEmployee:
        case formMode.indianDefault:
          return true
        case formMode.default:
        case formMode.otherCountryBusiness:
        case formMode.otherCountryEmployee:
          return false
        default:
          throw Error(
            `Apply Franchise Form shouldn't be in ${this.state.formMode}`
          )
      }
    }

    const setValueByCountry = (indianValue, otherCountryValue) => {
      if (isInIndianMode()) {
        this.setState({ formMode: indianValue })
      } else {
        this.setState({ formMode: otherCountryValue })
      }
    }

    if (BUSINESS.test(value) === true) {
      setValueByCountry(formMode.indianBusiness, formMode.otherCountryBusiness)
    } else if (EMPLOYEE.test(value) === true) {
      setValueByCountry(formMode.indianEmployee, formMode.otherCountryEmployee)
    } else {
      setValueByCountry(formMode.indianDefault, formMode.default)
    }
  }

  setFormOccupationModeState = () => {
    if (isIndia(this.state.residenceCountry)) {
      switch (this.state.formMode) {
        case formMode.default:
          this.setState({ formMode: formMode.indianDefault })
          break
        case formMode.otherCountryEmployee:
          this.setState({ formMode: formMode.indianEmployee })
          break
        case formMode.otherCountryBusiness:
          this.setState({ formMode: formMode.indianBusiness })
          break
        case formMode.indianEmployee:
        case formMode.indianBusiness:
        case formMode.indianDefault:
        default:
          break
      }
    } else {
      switch (this.state.formMode) {
        case formMode.indianDefault:
          this.setState({ formMode: formMode.default })
          break
        case formMode.indianEmployee:
          this.setState({ formMode: formMode.otherCountryEmployee })
          break
        case formMode.indianBusiness:
          this.setState({ formMode: formMode.otherCountryBusiness })
          break
        case formMode.default:
        case formMode.otherCountryEmployee:
        case formMode.otherCountryBusiness:
        default:
          break
      }
    }
    return null
  }

  handleCountryChange = e => {
    if (e !== undefined) {
      this.setState({ residenceCountry: e.target.value }, () =>
        this.setFormOccupationModeState()
      )
    } else {
      this.setFormOccupationModeState()
    }
  }
  handleBusinessCountryChange = e => {
    this.setState({ businessCountry: e.target.value })
  }

  handleSubmitFn = () => {
    // Do validation
    const isValidForm = this.validateAllFields()
    if (isValidForm) {
      this.submitFormData()
    }
  }

  handleSubmit = e => {
    if (e) {
      e.preventDefault()
    }

    this.handleSubmitFn()
  }

  renderOccupationSpecificDropdown = () => {
    const { formMode: currentMode } = this.state
    const { required } = this.props

    // TODO: Update props from netlify
    switch (currentMode) {
      case formMode.indianDefault:
      case formMode.default:
        return <EmptyInputComponent />
      case formMode.indianEmployee:
        return (
          <EmployeeeSelectInput
            type="text"
            placeholder={'Salary per annum'}
            innerRef={this.storeOccupationSpecificRef}
            onChange={this.handleChange}
            occupationListDropDownValues={employeeFields}
            required={required}
            validate={isRequired}
          />
        )
      case formMode.otherCountryEmployee:
        return (
          <InputComponent
            type="text"
            placeholder="Salary per annum (In dollars)"
            required={required}
            validate={isRequired}
            innerRef={this.storeOccupationSpecificRef}
            onChange={this.handleChange}
          />
        )

      case formMode.indianBusiness:
        return (
          <BusinessSelectInput
            type="text"
            placeholder={'Annual turnover'}
            innerRef={this.storeOccupationSpecificRef}
            onChange={this.handleChange}
            occupationListDropDownValues={businessFields}
            required={required}
            validate={isRequired}
          />
        )
      case formMode.otherCountryBusiness:
        return (
          <InputComponent
            type="text"
            placeholder="Annual turnover (In dollars)"
            required={required}
            validate={isRequired}
            innerRef={this.storeOccupationSpecificRef}
            onChange={this.handleChange}
          />
        )
      default:
        return <EmptyInputComponent />
    }
  }

  render() {
    const {
      submissionStatus,
      formMode: currentMode,
      residenceCountry,
      businessCountry
    } = this.state
    const {
      formData,
      glsLoaded,
      required,
      formHeading
      // occupationListDropDownValues
    } = this.props
    const {
      // formHeading,
      nameFieldPlaceholder,
      emailFieldPlaceholder,
      phoneNumberFieldPlaceholder,
      occupationFieldPlaceholder,
      ctaButtonText,
      thankYouTextOne,
      thankYouTextTwo
    } = formData[0].node.frontmatter
    if (currentMode === formMode.submitted) {
      return (
        <ResponsiveContainer>
          <SuccessContainer id="ApplyFranchiseFormThankYou">
            <SuccessText submitted={submissionStatus}>
              <PrimaryThankYouText
                dangerouslySetInnerHTML={{
                  __html: thankYouTextOne
                }}
              />
              <SecondaryThankYouText
                dangerouslySetInnerHTML={{
                  __html: thankYouTextTwo
                }}
              />
            </SuccessText>
            <Button
              type="button"
              onClick={this.goBack}
              id="ownAFranchiseFormOkButton"
            >
              {'OK'}
            </Button>
          </SuccessContainer>
        </ResponsiveContainer>
      )
    }
    return (
      <ApplyForFormSection>
        <Heading as="div">{formHeading}</Heading>
        {glsLoaded ? (
          <FormContainer id="ApplyFranchiseForm" autocomplete="off">
            <InputComponent
              type="text"
              placeholder={nameFieldPlaceholder}
              required={required}
              validate={isRequired}
              innerRef={this.storeNameRef}
              onChange={this.handleChange}
            />
            <InputComponent
              type="text"
              placeholder="Last Name"
              required={required}
              validate={isRequired}
              innerRef={this.storeLastNameRef}
              onChange={this.handleChange}
            />
            <AgeSelectInput
              type="text"
              placeholder="Age"
              required={required}
              validate={isRequired}
              innerRef={this.storeAgeRef}
              onChange={this.handleChange}
              occupationListDropDownValues={ageDropDownFields}
            />

            <InputComponent
              type="text"
              placeholder={emailFieldPlaceholder}
              required={required}
              validate={isValidEmailId}
              innerRef={this.storeEmailRef}
              onChange={this.handleChange}
            />

            <InputComponent
              type="text"
              placeholder={phoneNumberFieldPlaceholder}
              required={required}
              validate={isValidInternationalPhoneNumber}
              innerRef={this.storePhoneRef}
              onChange={this.handleChange}
            />
            <LocationSearchInput
              submissionStatus={submissionStatus}
              ref={this.storeCitiesInputRef}
              cityPlaceHolderText="City of Residence"
              handleChange={this.handleChange}
              onBlur={this.handleResidenceCityBlur}
              handleError={this.handleResidenceError}
              glsLoaded={glsLoaded}
              validate={isRequired}
              required={required}
              suggestionsContainerWidth="94%"
            />

            <InputComponent
              type="text"
              placeholder="Country"
              value={residenceCountry}
              required={required}
              validate={isRequired}
              innerRef={this.storeResidenceCountryRef}
              onChange={this.handleCountryChange}
              inputType="fullInput"
            />
            <OccupationSelectInput
              type="text"
              placeholder={occupationFieldPlaceholder}
              innerRef={this.storeOccupationRef}
              onChange={this.handleOccupationChange}
              occupationListDropDownValues={dropDownFields}
              required={required}
              validate={isRequired}
            />
            {this.renderOccupationSpecificDropdown()}

            <HaveYouExperienceIBCricketInput
              type="text"
              placeholder="Have you experienced iB Cricket?"
              required={required}
              validate={isRequired}
              occupationListDropDownValues={ClosedQuestionDropDownFields}
              innerRef={this.storeHaveYouExperienceIBCricketRef}
              onChange={this.handleChange}
            />
            <WhichOpportunityAreYouInterestedInput
              type="text"
              placeholder="Which opportunity are you interested in?"
              required={required}
              validate={isRequired}
              occupationListDropDownValues={WhichOpportunityAreYouInterestedInFields}
              innerRef={this.storeWhichOpportunityAreYouIntrested}
              onChange={this.handleChange}
            />
            <PreferredLocationHeading>
              {'Preferred location to set up iB Cricket Franchise?'}
            </PreferredLocationHeading>
            <LocationSearchInput
              submissionStatus={submissionStatus}
              ref={this.storePlacesInputRef}
              cityPlaceHolderText={'City/Town'}
              handleChange={this.handleChange}
              onBlur={this.handleBusinessCityBlur}
              handleError={this.handleBusinessError}
              glsLoaded={glsLoaded}
              required={required}
              suggestionsContainerWidth="97%"
            />
            <InputComponent
              type="text"
              placeholder="Country"
              value={businessCountry}
              required={required}
              validate={isRequired}
              innerRef={this.storeBusinessCountryRef}
              onChange={this.handleBusinessCountryChange}
            />

            <DoYouHaveSpaceAvailableForSetupField
              type="text"
              placeholder="Is space available for the setup?"
              required={required}
              validate={isRequired}
              occupationListDropDownValues={ClosedQuestionDropDownFields}
              innerRef={this.storeDoYouHaveSpaceAvailableForSetupRef}
              onChange={this.handleChange}
            />

            <RadioButtonContainer>
              <RadioButtonHeading>
                Any previous experience in business?
              </RadioButtonHeading>
              <RadioButtonsWrapper>
                <label className="radioButtonContainer">
                  <RadioButtonLabel>Yes</RadioButtonLabel>
                  <input
                    id="YesRadioButton"
                    type="radio"
                    name="radio"
                    value="Yes"
                    onChange={this.handleChange}
                  />
                  <span className="checkmark" />
                </label>
                <label className="radioButtonContainer">
                  <RadioButtonLabel>No</RadioButtonLabel>
                  <input
                    id="NoRadioButton"
                    type="radio"
                    name="radio"
                    value="No"
                    onChange={this.handleChange}
                  />
                  <span className="checkmark" />
                </label>
              </RadioButtonsWrapper>
            </RadioButtonContainer>
            <WhyAreYouInterestedHeading>
              {'Why are you interested in taking up business with iB Cricket?'}
            </WhyAreYouInterestedHeading>
            <TextAreaComponent
              type="textarea"
              placeholder=""
              required={required}
              validate={isRequired}
              innerRef={this.storeWhyAreYouInterestedRef}
              onChange={this.handleChange}
              inputType="fullInput"
            />

            <ButtonWrapper>
              <Button
                type="submit"
                onClick={this.handleSubmit}
                id="ownAFranchiseFormSubmitButton"
                as="button"
              >
                {ctaButtonText}
              </Button>
            </ButtonWrapper>
          </FormContainer>
        ) : (
          <Loading>Loading ... </Loading>
        )}
      </ApplyForFormSection>
    )
  }
}

export default ApplyForFranchiseForm



// WEBPACK FOOTER //
// ./src/components/ApplyFranchiseComponent/ApplyForFranchiseForm/index.js